import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'assess-assistant',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './assess-assistant.component.html',
  styleUrl: './assess-assistant.component.css'
})
export class AssessAssistantComponent implements OnInit {

  icons = Icons;
  suggestion: string = '';  
  basePath: string = '';

  showChatbox: boolean = false;
  loading: boolean = false;

  private routerSubscription!: Subscription;

  constructor(
    private router: Router,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.setBasePathFromUrl(this.router.url);

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.setBasePathFromUrl(event.urlAfterRedirects);
      });
  }

  setBasePathFromUrl(url: string) {
    this.basePath = url.split('/')[1];
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.onClose(); 
    }
  }

  openChatbox(): void {
    this.showChatbox = !this.showChatbox;
  }
  
  onClose(): void {
    this.showChatbox = false;
  }
}
